
import { React, useEffect, useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const PaymentConfirmationDialog = ({ open, onClose, user }) => {
    const RAZORPAY_KEY = "rzp_test_R1E4A2whW7RqSn"; // Replace with your Razorpay Test Key ID// Replace with your Google Apps Script URL
    const API_BASE_URL = "https://gcp-poc-with-apollo-1081525845464.asia-south1.run.app";
    const handlePayment = () => {
        console.log("Processing payment for member:", user);
        onClose();
    };
    const [orderId, setOrderId] = useState(null);
    const [finalAmount, setFinalAmount] = useState(null);
    const paymentContainer = useRef(null);

    const fetchOrder = async () => {
   
        try {
            const amount = 2000;
            const mobile = user.Mobile_Number
            const response = await fetch(`${API_BASE_URL}/create-order`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ amount, mobile }) // Send amount for the order creation
            });

            if (!response.ok) {
                throw new Error(`Server Error: ${response.status}`);
            }
            const orderData = await response.json();
            console.log("Order Data:", orderData);

            if (!orderData.orderId || !orderData.amount) {
                throw new Error("Invalid order response");
            }
            // Set orderId and amount (in paise)

            setOrderId(orderData.orderId);
            setFinalAmount(orderData.amount);
        } catch (error) {
    
            console.error("Error fetching order:", error);
            alert("Failed to create order. Please try again.");
        }
    };
    useEffect(() => {
        const mobile = localStorage.getItem("mobile");

        if (orderId && finalAmount && paymentContainer.current) {
            const options = {
                key: RAZORPAY_KEY,
                amount: finalAmount,
                currency: "INR",
                name: "TKS Trust",
                description: "UPI QR Payment",
                order_id: orderId,
                image: "/CWA_logo.png", // 🔹 Add a custom logo
                theme: {
                    color: "#FFA500", // 🔹 Primary brand color

                    hide_topbar: false, // 🔹 Show/hide the top bar
                },
                modal: {
                    backdropclose: false, // 🔹 Prevent closing by clicking outside
                    confirm_close: true, // 🔹 Ask for confirmation before closing
                    animation: true, // 🔹 Smooth opening animation
                },
                handler: async function (response) {
                    console.log("Payment Successful:", response);

                    localStorage.setItem("payment_completed", "true");

                    const mobile = localStorage.getItem("mobile");

                    // Now, instead of calling Google Apps Script, we'll call your backend to verify payment
                    const verifyParams = new URLSearchParams({
                        paymentId: response.razorpay_payment_id, // Razorpay Payment ID
                        orderId: orderId, // Order ID
                    }).toString();

                    try {
                        const verifyResponse = await fetch(`${API_BASE_URL}/verify-payment`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                paymentId: response.razorpay_payment_id,
                                orderId: orderId,
                                signature: response.razorpay_signature, // Include signature if needed for verification
                            }),
                        });
                        const verifyData = await verifyResponse.json();
                        onClose();
                        window.location.reload();
                    
                    } catch (error) {
                    
                        console.error("Error verifying payment:", error);
                        
                    }
                },
                payment_capture: 1,
                method: {
                    upi: true,
                    netbanking: true,
                    card: true,
                },
                upi: {
                    flow: "collect",
                },
                prefill: {
                    contact: mobile,
                },
                container: paymentContainer.current, // Embed inside this div
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open();
        }
    }, [orderId, finalAmount]);

    return (
        <Dialog open={open} onClose={onClose}>
             <div ref={paymentContainer} id="razorpay-container" style={{ width: "100%", height: "0px" }}></div>
            <DialogTitle>Confirm Payment</DialogTitle>
            <DialogContent>
                <Typography>Do you want to proceed with payment for the following member?</Typography>
                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    <b>Name:</b> {user?.First_Name || "N/A"}<br />
                    <b>Member ID:</b> {user?.id || "N/A"}<br />
                    <b>Mobile:</b> {user?.Mobile_Number || "N/A"}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button color="success" onClick={fetchOrder}>Pay Now</Button>
            </DialogActions>
        </Dialog>
    );
};

export default PaymentConfirmationDialog;
